module.exports = __webpack_public_path__ + "static/media/tsforest.95c60298.png";